import { memo } from "react";

function RecoveryTime_Icon() {
  return (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 18.4424C3.24714 17.4592 4.16141 16.7353 5.1377 16.207C7.12 15.1345 9.30684 14.9043 10.5332 14.7471C11.2572 14.6542 12.2273 14.5721 12.9521 14.499C13.1378 14.4803 13.3067 14.4628 13.4561 14.4453C13.4622 14.4079 13.4696 14.3687 13.4766 14.3271C13.564 13.8048 13.6938 13.0814 13.9316 12.2686C14.4073 10.6427 15.3287 8.60756 17.2695 6.96484C18.7429 5.71783 20.7991 4.55821 23.6787 3.79199C23.7861 3.76344 23.8939 3.75006 24 3.75V6.29688C21.6267 6.97174 20.0047 7.92517 18.8848 8.87305C17.441 10.0951 16.7228 11.6319 16.3311 12.9707C16.1354 13.6396 16.0248 14.2469 15.9424 14.7393C15.9036 14.9708 15.8641 15.2196 15.8271 15.4072C15.8082 15.5038 15.7843 15.6167 15.752 15.7266C15.7268 15.8121 15.6655 16.01 15.5322 16.2051C15.3199 16.5157 15.03 16.6439 14.9707 16.6709C14.8609 16.7209 14.7578 16.7516 14.6885 16.7705C14.5453 16.8096 14.3874 16.839 14.2461 16.8613C13.9552 16.9073 13.5837 16.9479 13.2021 16.9863C12.4052 17.0666 11.5325 17.1393 10.8516 17.2266C9.5395 17.3948 7.83083 17.5926 6.32715 18.4062C5.24756 18.9904 4.24511 19.9111 3.65625 21.5H24V24H0V0H2.5V18.4424Z"
        fill="currentColor"
      />
      <path
        d="M28.25 8C25.355 8 23 10.355 23 13.25C23 16.145 25.355 18.5 28.25 18.5C31.145 18.5 33.5 16.145 33.5 13.25C33.5 10.355 31.145 8 28.25 8ZM30.7468 15.9655C30.6615 16.0508 30.5495 16.0938 30.4375 16.0938C30.3255 16.0938 30.2135 16.0508 30.1282 15.9655L27.9407 13.7781C27.8584 13.6963 27.8125 13.5851 27.8125 13.4688V10.625C27.8125 10.3831 28.0085 10.1875 28.25 10.1875C28.4915 10.1875 28.6875 10.3831 28.6875 10.625V13.2877L30.7468 15.3469C30.9179 15.518 30.9179 15.7945 30.7468 15.9655Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(RecoveryTime_Icon);
